import React from 'react'
import { Link } from 'react-router-dom'

const Product = ({img, text, link}) => {
  return (
    <Link to={link}>
    <div class="wow zoomIn">
        <div class="card">
            <img class="card-img-top" src={img} alt={text}/>
            <div class="card-body">
                <h5 class="card-text text-black">{text}</h5>
                <a href={link} class="product-link">More Details</a>
            </div>
        </div>
    </div>  
    </Link>
  )
}

export default Product